<template>
<div>
   <PageTitle  
   v-if="Purchase.status=='Pending'" 
   title="Purchase View"   
   :backBtn = true 
   :editRoute="'/purchase/edit/' + this.$route.params.id"  
   :permission="'Purchase Edit'"   
   :changeStatus="true"    
   @onClickChangeStatus="onClickChangeStatus"    
   :printvisible="true" 
   @openPrintmethod="GotoPrintDetails"
   />
  <PageTitle 
  v-if="Purchase.status!='Pending'" 
  title="Purchase View" 
  :backBtn = true
  :printvisible="true"
  @openPrintmethod="GotoPrintDetails"
  />
  <v-container fluid class="lighten-12 container">
    <v-row>
      <v-col cols="12" sm="12" md="8" lg="8">
        
              <v-card class="lighten-12">
                <v-card-title class="v-card__title"
                  ><v-icon color="blue" small>mdi-sale</v-icon><span class="ml-3"> Purchase
                  Details</span></v-card-title
                >
                <v-container fluid class="container saledetailscard">
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                      <v-row class="pt-0">
                        <v-col
                          cols="12"
                          sm="12"
                          md="4"
                          lg="4"
                          class="pr-5pt-1.5 pb-1 reference_number"
                        >
                          <v-icon>mdi-sale</v-icon>
                          {{
                            Purchase.referenceNumber
                              ? Purchase.referenceNumber
                              : "----"
                          }}
                        </v-col>

                        <v-col
                          cols="12"
                          sm="12"
                          md="4"
                          lg="4"
                          >
                          <span class="statustext pr-5">Status</span>
                          <v-chip
                            label
                            text-color="white"
                            style="
                              font-variant-caps: all-small-caps;
                              font-weight: bold;
                            "
                            :color="getPurchaseOrderStatusColor(Purchase.status)"
                            dark
                            >
                            {{ Purchase.status ? Purchase.status : "----" }}
                          </v-chip></v-col
                        >

                        <v-col
                          cols="12"
                          sm="12"
                          md="4"
                          lg="4"
                        >
                          <span class="statustext pr-5">Status Note</span>
                          
                            {{ Purchase.statusNote?Purchase.statusNote:"-----"}}
                          </v-col
                        >
                      </v-row>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="4"
                          lg="4"
                          class="shoptext pr-5 pt-0 mt-5"
                        >
                          <v-row class="subtextlable"> Supplier </v-row>
                          <v-row>
                            {{ Purchase.suppliers ? Purchase.suppliers.name : "" }}
                          </v-row>
                        </v-col>
                        <v-col cols="12" sm="12" md="1" lg="1" class="shoptext pr-5 pt-0 mt-7">
                          <v-divider></v-divider>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="3"
                          lg="3"
                          class="shoptext pr-5 pt-0 mt-5"
                        >
                          <v-row class="subtextlable"> Warehouse </v-row>
                          <v-row>
                            {{Purchase.warehouses ? Purchase.warehouses.name : ""}}
                          </v-row>
                        </v-col>

                        <v-col cols="1" sm="12" md="1" lg="1" class="shoptext pr-5 pt-0 mt-7">
                          <v-divider></v-divider>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="3"
                          lg="3"
                          class="shoptext pr-5 pt-0 mt-5"
                        >
                          <v-row class="subtextlable"> Purchase Date </v-row>
                          <v-row>
                            <v-icon small>mdi-calendar</v-icon>
                            {{ Purchase.date | formatDate }}
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
          
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="4">
        <v-row>
          <v-col  cols="12" sm="12" md="12" lg="12">          
            <v-card class="lighten-12">
                <v-card-title class="d-flex justify-space-between"> Additional Amounts<div>
          <v-btn hidden small dark  color="indigo" @click="OpenAdditionalPayment()"><v-icon dark > mdi-cash </v-icon></v-btn
          ></div></v-card-title>
              <v-container class="ma-0 pa-0 pb-1">
                <v-row class="ma-0 pa-0">

                  <v-col cols="12" sm="12" md="12" lg="12" class="ma-0 pa-0">
                    <v-expansion-panels class="ma-0 pa-0">
                      <v-expansion-panel class="ma-0 pa-0">
                        <v-expansion-panel-header class="container saledetailscard pt-3">
                          <v-row>
                            <v-col cols="4" sm="12" md="6" lg="6" class="Ui1 pt-5 ma-0" >
                              <div style="font-weight:bold">Total Amount</div>      
                            </v-col>
                            <v-col cols="5" sm="12" md="6" lg="6" class="Ui1 ma-0">    
                              <v-chip  label>
                                <div style="font-weight:bold">{{ AdditionalTotal| formatCurrency }}</div>
                              </v-chip>
                            </v-col>
                          </v-row>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="ma-0 pa-0">
                          <v-data-table
                              :headers=" AdditionalAmountHeaders"
                              :items="Purchase.additionalAmounts"
                              class="ma-0 pa-0"
                              hide-default-footer
                          disable-pagination>
                            <template v-slot:item.action="{ item }">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                  small
                                  class="mr-2"
                                  @click="EditAdditionalAmount(item)"
                              >
                                mdi-pencil
                              </v-icon>
                                </template>
                                <span>Edit Amount</span>
                              </v-tooltip>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                  small
                                  @click="DeleteAdditionalAmount(item)"
                              >
                                mdi-delete
                              </v-icon>
                                </template>
                                <span>Delete Amount</span>
                              </v-tooltip>

                            </template>
                          </v-data-table>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                   
                  </v-col>
                </v-row>
                <AdditionalAmountModel
                    ref="AdditionalAmount"
                    @conform="refreshAdditionalAmountTable"
                    :AdditionalAmount="additionalAmount"
                    :purchaseId="purchaseId"

                />
                <EditPaymentModel
                    ref="PaymentEditModel"
                    @conform="refreshPayments"
                    :visible="showEditForm"
                    :debitAccount="debitAccount"
                    :payment="payment"
                    :creditAccounts="supplierCreditAccounts"
                />
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" class="pt-1">
        <v-card class="lighten-12">
          <v-card-title class="d-flex justify-space-between">Purchase Products </v-card-title>
          <v-container fluid class="pa-2 container saledetailscard">
            <PurchaseTemplate
                id="purchase"
                :purchase="Purchase"
                class="test1"
                :total="selectedProductsTotal"
                :purchaseProducts="selectedProductsItems" 
                style="display: none"

            ></PurchaseTemplate>
            <v-row >
           

              <v-col cols="12" class="px-0">
                <v-data-table disable-pagination
                              hide-default-footer
                              :headers="purchaseorderheaders" 
                              :items="selectedProductsItems" 
                              sortable: false 
                              class="row-pointer">
                
                    <!-- <template v-slot:item.amount="{ item }">
                              {{item.amount | formatCurrency}}
                            </template> -->
                  <template slot="footer"      v-if="selectedProductsTotal > 0" class="black--text">
                    <!-- <v-row>
                    <v-col sm="6" md="10" lg="10" class="title pl-6">Total</v-col>
                    <v-col class="title text-lg-center text-md-left text-right pr-0 pr-sm-15 pr-md-15 pr-lg-5">{{ grandTotal | formatCurrency }}</v-col>
                    </v-row> -->
                  </template>


                  <template v-slot:item.total="{ item }">
                    <strong class="px-4">  </strong>
                  </template>

                  <template slot="body.footer">
                        
                    <th class="title"></th>
                    <th class="title"></th>
                    <th class="title"></th>
                    <th class="title"></th>
                    <th class="title"></th>
                    <th class="title"></th>
                    <th class="title"></th>
                    <th class="title"></th>
                    <th class="text-right">
                      <h3>  {{
                              Purchase.totalDiscountAmount
                                | formatCurrency
                            }}
                      </h3>
                    </th>
                    <th class=" text-right">
                      <h3>  {{ selectedProductsTotal |formatCurrency }}</h3>
                    </th>
                    <!-- </tr> -->
                  </template>
                  <template
                   v-slot:item.discountPercentage="{ item }"
                   v-slot="{ errors }"
                   name="Quantity"
                   rules="numeric"
                  >
                    <div style="font-weight:bold">
                      {{item.discountPercentage}} %
                    </div>
                  </template>
                  <template v-slot:item.discountAmount="{ item }">
                    <div style="font-weight:bold">
                      {{ item.discountAmount | formatCurrency }}
                    </div>
                  </template>
                  <template v-slot:item.batch.name="{ item }">
                    <div style="font-weight:bold">
                      {{item.batch ? item.batch.name:""}}
                    </div>
                  </template>

                  <template v-slot:item.quantity="{ item }">
                    <div style="font-weight:bold">
                      {{ item.quantity }}
                    </div>
                  </template>

                  <template v-slot:item.amount="{ item }">
                    <div style="font-weight:bold">
                      {{ item.amount }}
                    </div>
                  </template>

                  <template v-slot:item.damage="{ item }">
                    <div style="font-weight:bold">
                      {{ item.damage }}
                    </div>
                  </template>

                  <template v-slot:item.discount="{ item }">
                    <div style="font-weight:bold">
                      {{ item.discount }}
                    </div>
                  </template>

                  <template v-slot:item.unitPrice="{ item }">
                    <div style="font-weight:bold">
                      {{ item.unitPrice }}
                    </div>
                  </template>

                  <template v-slot:item.unit.name="{ item }">
                    <div style="font-weight:bold">
                      {{ item.unit ? item.unit.name : ""}}
                    </div>
                  </template>

                  <template v-slot:item.name="{ item }">
                    <div style="font-weight:bold">
                      {{item ? item.name : "" }}
                    </div>
                  </template>

                </v-data-table>

              </v-col>

            </v-row>

            <v-row class="blue darken-1 white--text font-weight-black title mx-1">
              


              <v-col cols="12" lg="6" sm="12" class="saletiltle text-right">
                <strong>
                
                  Discount Amount : {{Purchase.discountAmount}}
                </strong>
          
              
              </v-col>
              <v-col cols="12" lg="6" sm="12" class="saletiltle text-right">
                <strong class="mr-5"> Total Payable Amount : 
                  
              
                  {{
                    (selectedProductsTotal -
                        (Purchase.totalDiscountAmount?Purchase.totalDiscountAmount:0) -
                        (Purchase.discountAmount?Purchase.discountAmount:0))
                        | formatCurrency
                  }}
                </strong>
              </v-col>
            </v-row>
          </v-container>
        </v-card>



      </v-col>
      <v-col cols="12" sm="12" md="12" lg="12" class="pt-1">
              <v-card class="lighten-12">
                <v-card-title class="d-flex justify-space-between">  Payments Summary <div>
           <v-btn hidden small dark class="text-white w-100 ma-1 d-none d-sm-flex justify-content-end" color="indigo" @click="OpenPayment()"
          ><v-icon dark > mdi-cash </v-icon></v-btn
          ></div></v-card-title>

                <v-container fluid class="container saledetailscard">
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                      <v-row v-if="Purchase.payments.length == 0">
                        <v-col cols="12" sm="12" md="12" lg="12" class="d-flex justify-content-center font-weight-bold">
                          No payments yet!
                        </v-col>
                      </v-row>
                      <v-row
                        class="pt-0"
                        v-else
                        v-for="payement in Purchase.payments"
                        :key="payement"
                      >
                        <v-col
                          cols="2"
                          sm="12"
                          md="2"
                          lg="2"
                          class="pr-5 pt-1.5 pb-1 shoptext"
                        >
                          <v-icon small>mdi-calendar</v-icon>
                          {{ payement.date_time | formatDate }}
                        </v-col>
                        <v-col
                          cols="2"
                          sm="12"
                          md="2"
                          lg="2"
                          class="pr-5pt-1.5 pb-1 shoptext"
                        >
                          LKR {{ payement.amount | formatCurrency }}
                        </v-col>

                        <v-col
                          cols="4"
                          sm="12"
                          md="4"
                          lg="4"
                          style="text-align: right"
                          ><span class="statustext pr-5">Payment Status</span
                          ><v-chip
                            label
                            text-color="white"
                            style="
                              font-variant-caps: all-small-caps;
                              font-weight: bold;
                            "
                            :color="GetChequeStatusColor(payement.status)"
                            dark
                            >{{ payement.status }}</v-chip
                          ></v-col
                        >

                        <v-col
                          cols="3"
                          sm="12"
                          md="3"
                          lg="3"
                          style="text-align: right"
                        >
                          <span class="statustext pr-5">Payment Type</span>
                          <v-chip
                            label
                            style="
                              background-color: #c11e65;
                              color: white;
                              font-variant-caps: all-small-caps;
                              font-weight: bold;
                            "
                          >
                            {{
                              payement.payment_type
                                ? payement.payment_type
                                : "----"
                            }}
                          </v-chip></v-col
                        >
                        <v-col
                          cols="1"
                          sm="12"
                          md="1"
                          lg="1"
                          class="pr-3 pt-1.5 pb-2  shoptext"
                        >
                         <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                           v-bind="attrs"
                          v-on="on"
                            v-if="
                              (
                                item.status == 'Pending' &&
                                item.payment_type == 'Cheque'
                              )
                            "
                            small
                            class="mr-2 pb-2 mt-1"
                            color="primary"
                            @click.stop="EditPayment(payement)"
                          >
                            mdi-pencil
                          </v-icon>
                        </template>
                         <span>Edit</span>
                           </v-tooltip>
                           <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                          <v-icon
                          v-bind="attrs"
                          v-on="on"
                            small
                            @click="ViewPayment(payement)"
                            color="green"
                            class="mr-2 pb-2 mt-1"
                          >
                            mdi-eye
                          </v-icon>
                          </template>
                           <span>View</span>
                           </v-tooltip>
                        </v-col>
                       
                    
                      </v-row>
                      
                      <v-row class="blue darken-1 white--text font-weight-black title mx-1">
              


                        <v-col cols="12" lg="4" sm="12" class="saletiltle text-center">
                          <strong>
                          
                            Amount Paid : {{ paidAmount | formatCurrency}}
                          </strong>
                    
                        
                        </v-col>

                        <v-col v-if="AdditionalTotal > 0" cols="12" lg="4" sm="12" class="saletiltle text-center text-danger">
                          <strong>
                          
                            Additional Amount : {{ AdditionalTotal | formatCurrency}}
                          </strong>
                    
                        
                        </v-col>
                        
                
                        <v-col cols="12" lg="4" sm="12" class="saletiltle text-right">
                          <strong class="mr-5"> Total Payable Amount : 
                        
                            {{
                              (selectedProductsTotal + AdditionalTotal - (Purchase.totalDiscountAmount?Purchase.totalDiscountAmount:0) - (Purchase.discountAmount?Purchase.discountAmount:0 )-
                                  (paidAmount?paidAmount:0))
                                  | formatCurrency
                            }}
                          </strong>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>

              <AddPaymentModel
                    ref="PaymentModal"
                    :PayableBalance="Purchase.balance"
                    @conform="refreshPayments"
                    :visible="showScheduleForm"
                    :debitAccount="debitAccount"
                    :creditAccounts="debitAccount"
                    :payment="payment"
                    :purchaseId="purchaseId"
                    :supplierId="Purchase.supplier_id"
                />

              <SalesPaymentEditModal
                ref="PaymentEditModel"
                @conform="refreshPayments"
                :visible="showEditForm"
                :debitAccount="debitAccount"
                :salesId="Purchase.id"
                :payment="payment"
                :creditAccounts="supplierCreditAccounts"
              />
            </v-col>
    </v-row>
    <v-row class="purchasedetails">
      <v-col cols="12" sm="12" md="12" lg="12" class="pt-1 ">
        <AuditLogs :Type="'purchase'" />
           
      </v-col>

    </v-row>


    <v-row>
     





      <v-col cols="12" sm="12" md="12" lg="12" class="pt-1">
        <v-card class="lighten-12">
          <v-card-title>Files</v-card-title>
          <v-container fluid>
            <v-row>
              <v-col cols="12" sm="12" lg="12">
                <FileUpload
                    :multiple="true"
                    size="2048"
                    icon="mdi-upload"
                    autoupload="true"
                    :url="'document/upload/purchase/' + this.$route.params.id"
                    :showDocumentView="true"
                    :documentsUrl="'document/purchase/'+this.$route.params.id"
                    downloadUrl="document/:id/download"
                    removeUrl="document/:id"
                ></FileUpload>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>

       <v-col cols="12" sm="12" md="12" lg="12" class="py-1" v-if="true">
        <v-card class="lighten-12">
          <v-card-title>Note</v-card-title>
          <v-container fluid>
            <v-row >
                <v-col cols="6" sm="6" md="3" lg="3">{{Purchase.remark}}</v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
        <change-status
        :visible="visibleChangeStatusModal"
        :statuses="purchaseStatuses"
        :statusNote="Purchase.statusNoteChange"
        :selectedStatus="Purchase.status"
        @onChangeStatus="onChangeStatus"
        @close="onCloseChangeStatus"
      ></change-status>

      <!-- Purchase bill -->
      <purchasebill
        ref = "CallingBill"
        :ProductData = "selectedProductsItems"
        :PaymentDetails = "payments"
        :PurchaseDetails = "Purchase"
        :Suppliers = "Supplier"
        :TotalAdditionalAmount = "AdditionalTotal"
        :SubTotal = "Total"
        :ProductDiscount = "Purchase.totalDiscountAmount"
        @closePreview = "closePreview"
        v-show = "false"
        :visible ="purchaseBillVisible"
      />
  </v-container>
</div>
</template>

<script>
import purchasebill from "@/components/shared/PurchaseBill.vue";
import ChangeStatus from "@/components/shared/ChangeStatus";
import { PurchaseViewModel } from "@/models/View Models/PurchaseViewModel";
import { PaymentViewModel } from "@/models/View Models/PaymentViewModel";
import FileUpload from "@/components/base/FileUpload";
import DocumentView from "@/components/base/DocumentView";
import AddPaymentModel from "../../shared/modals/AddPaymentModel";
import AdditionalAmountModel from "../../shared/modals/AddAdditionalAmountModal";
import EditPaymentModel from "../../shared/modals/EditPaymentModel";
import { AccountViewModel } from "../../../models/View Models/AccountViewModel";
import { Payment } from "@/models/Payment";
import "jspdf-autotable";
import VueDocPreview from "vue-doc-preview";
import confirmation from "@/modules/shared/components/confirmation";
import _ from "lodash";
import SalesPaymentEditModal from "../../../modules/shared/modals/SalesPaymentEditModal.vue"

export default {
  data: () => ({
    Purchase: [],
    visibleChangeStatusModal: false,
    purchaseStatuses: [
      { requiredNote: false, status: "Completed" },
      { requiredNote: false, status: "Pending" },
      { requiredNote: true, status: "Canceled" },
    ],
    purchaseStatus: ["Completed", "Canceled","Pending"],
    payment: [],
    showEditForm: false,
    purchaseId: "",
    payments: [],
    StatusReasonErrorMessages:[],
    additionalAmount: {
      amount: 0,
      reason: "",
      isEdit: false,
      id: null,
    },
    Total:0,
    showScheduleForm: false,
    AdditionalTotal: 0,
    debitAccount: [],
    supplierCreditAccounts: [],
    PaymentViewModel: [],
    paidAmount: 0,
    additionalAmounts:[],
    purchaseBillVisible: false,
      
    selectedProductsItems: [],
    ChequeStatus: ["Pending", "Canceled", "Completed"],
    purchaseorderheaders: [
      { text: "Name", value: "name", sortable: false, width: "20" },
      { text: "Batch", value: "batch.name", sortable: false, width: "20" },
      { text: "Unit", value: "unit.name", sortable: false, width: "20" },
      {
        text: "Unit Cost",
        value: "unitPrice",
        align: "center",
        width: "10%",
      },
      {
        text: "Discount %",
        value: "discountPercentage",
        sortable: false,
        width: "10%",
        align:"center"
      },
      {
        text: "Qty",
        value: "quantity",
        sortable: false,
        align: "center",
        width: "10",
      },
      {
        text: "Discount Qty",
        value: "discount",
        sortable: false,
        align: "center",
        width: "10",
      },
      {
        text: "Damage Qty",
        value: "damage",
        sortable: false,
        align: "center",
        width: "10",
      },

      {
        text: "Discount Amount",
        value: "discountAmount",
        align: "right",
        width: "15%",
      },
      {
        text: "Total",
        value: "amount",
        sortable: false,
        align: "right",
        width: "10",
      },
    ],
    paymentHeaders: [
      { text: "Date", value: "date_time" },
      { text: "Reference Number", value: "reference_number" },
      { text: "Amount", value: "amount" },
      { text: "Payment Type", value: "payment_type" },
      { text: "status", value: "status", align: "center" },
      { text: "", value: "action" },
    ],
    AdditionalAmountHeaders: [
      { text: "Amount", value: "amount", width: "20" },
      { text: "Reason", value: "reason", width: "90" },
      {
        text: "",
        value: "action",
        sortable: false,
        align: "right",
        width: "5",
      },
    ],
    selectedProductsTotal: 0,
  }),
  methods: {

    onChangeStatus(value) {
      value.id=this.$route.params.id
      this.$store
        .dispatch("purchase/ChangeStatus", value)
        .then((res) => {
          this.GetPurchase();
            this.visibleChangeStatusModal = false;

        })
        .catch((err) => {
          this.isLoading = false;
        });
    },
    ViewPayment(item) {
      this.$router.push(`/payment/${item.id}`);
    },
     onClickChangeStatus(value) {
      this.visibleChangeStatusModal = true;
    },
    onCloseChangeStatus() {
      this.visibleChangeStatusModal = false;
    },
    sumField(key) {
      // sum data in give key (property)

      this.selectedProductsTotal = this.selectedProductsItems.reduce(
        (a, b) => a + (b[key] || 0),
        0
      );
    },
    sumSubTotal(array, field){
      let value = 0
      array.forEach((element) => {
        value += parseFloat(element[field]);
      });
      return value;
    },
    SumAdditionalAmount() {
   
      this.AdditionalTotal = 0;
      this.Purchase.additionalAmounts.map((p) => {
        this.AdditionalTotal = this.AdditionalTotal + p.amount;
      });
    },
    GetSelectedUnitPriceDetails(product, unit) {
      if (product.batch && product.batch.unitPriceDetails) {
        var selectedUnit = product.batch.unitPriceDetails.find(
          (i) => unit.id === i.unit
        );
        if (selectedUnit) {
          product.unitPrice = selectedUnit.purchasePrice;
        }
      }
    },
    sumDiscountField(key) {
      this.Purchase.totalDiscountAmount = this.selectedProductsItems.reduce(
        (a, b) => a + (b[key] || 0),
        0
      );
    },
    GetPurchase() {
      this.purchaseId = this.$route.params.id;
      this.$store
        .dispatch("purchase/GetPurchase", this.purchaseId)
        .then(async (res) => {
          this.Purchase = new PurchaseViewModel(res.data);
          await this.getOrganization();
          this.SumAdditionalAmount();
          this.selectedProductsItems = this.Purchase.products;
          this.Supplier = this.Purchase.supplier;
          this.additionalAmounts = this.Purchase.additionalAmounts;
          
          this.payments = this.Purchase.payments;
          this.paidAmount = 0;
          this.payments.forEach((i)=>{ 
            if (i.status == 'Completed' || i.status == 'Pending'){
                this.paidAmount = this.paidAmount + parseInt(i.amount);
            }
                      })
          this.AdditionalTotal = 0;
          this.additionalAmounts.forEach((i) => {
            this.AdditionalTotal = this.AdditionalTotal + i.amount;
          })
          this.selectedProductsItems.forEach((product) => {
            this.GetSelectedUnitPriceDetails(product, product.unit);
            product.total = product.quantity * product.unitPrice;
            product.discountAmount = parseInt(
              product.discount * product.unitPrice +
                (product.received - product.discount) *
                  (product.unitPrice * (product.discountPercentage / 100))
            );
            product.unitError = [];
          });
          this.Total = this.sumSubTotal(this.selectedProductsItems, "amount")
          this.sumField("total");
          this.sumDiscountField("discountAmount");
          this.selectedProducts = [];
          this.Purchase.products.forEach((product) => {
            const tempProduct = this.products.find(
              (item) => item.id === product.product_id
            );
            tempProduct.quantity = product.quantity;
            this.selectedProducts.push(tempProduct);
          });
        
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
         // this.messages = err.data.title;
        });
    },

    DocumentView() {
      var fileId = this.$route.params.id;
      var documentType = "PURCHASE";
      this.$store
        .dispatch("DocumentView", {
          fileId,
          documentType,
        })
        .then((resp) => {
       
        });
    },
    OpenPayment() {
      this.payment = new Payment();
      this.$refs.PaymentModal.openModal();
    },

    OpenAdditionalPayment() {
      this.additionalAmount = {
        amount: 0,
        reason: null,
        isEdit: false,
        id: null,
      };
      this.$refs.AdditionalAmount.openModal();
    },
    changeStatus()
    {
      this.Purchase.isUpdate = !this.Purchase.isUpdate
      if(!this.Purchase.isUpdate)
      {
        this.Purchase.isUpdate=true;
        this.UpdateStatus();
      }


    },
    EditPayment(item) {
      this.payment.account_id = this.Purchase.account_id;
      this.payment = _.cloneDeep(item);
      if (this.payment.cheque) {
        this.payment.cheque_bank = item.cheque.cheque_bank;
        this.payment.cheque_date = item.cheque.cheque_date;
        this.payment.cheque_no = item.cheque.cheque_no;
        this.payment.cheque_type = item.cheque.cheque_type;
      }

      this.$refs.PaymentEditModel.openModal();
    },

    GetDebitAccounts() {
      this.$store
        .dispatch("purchase/GetDebitAccounts", { accountType: "Purchase" })
        .then((res) => {
          this.debitAccount = res.data.data.map((u) => {
            return new AccountViewModel(u);
          });
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.title;
        });
    },

    refreshPayments() {
      this.GetPurchase();
    },
    GetChequeStatusColor(status) {
      switch (status) {
       case "Completed":
          return "green";
          break;
        case "Pending":
          return "orange";
          break;
        case "Canceled":
          return "red";
          break;
        case "Return":
          return "#973a5a";
          break;
        default:
          break;
      }
    },
    EditAdditionalAmount(item) {
      this.additionalAmount = {
        amount: item.amount,
        reason: item.reason,
        isEdit: true,
        id: item.id,
      };
      this.$refs.AdditionalAmount.openModal();
    },
    DeleteAdditionalAmount(item) {
      confirmation.dialog = true;
      this.$confirm("Do you want to Delete this Additional Amount").then(
        (res) => {
         
          if (res) {
            this.$store
              .dispatch(`purchase/DeleteAdditionalAmount`, {
                id: item.id,
                purchaseId: this.purchaseId,
              })
              .then((res) => {
                this.isLoading = false;
                this.$toast.success("Additinal amount deleted successfully");
                this.refreshPayments();
                this.show = false;
              })
              .catch((err) => {
                this.isLoading = false;
                this.$toast.error("Failed to delete additional amount");
                this.show = false;
              });
          }
        }
      );
    },
    UpdateStatus() {
      if(this.Purchase.statusChange=='Canceled' && this.Purchase.statusNoteChange==null)
      {
        this.StatusReasonErrorMessages.push('Reason is Required')
      }
      else
      {
        this.StatusReasonErrorMessages=[];
        confirmation.dialog = true;
        this.$confirm(`Do you want to ${this.Purchase.statusChange} Purchase`).then(
            (res) => {
              if (res) {
                this.$store
                    .dispatch(`purchase/UpdatePurchaseStatus`, {
                      purchaseId: this.purchaseId,
                      data: {
                        status: this.Purchase.statusChange,
                        status_note: this.Purchase.statusNoteChange
                      }
                    })
                    .then((res) => {
                      this.GetPurchase()
                      this.$toast.success("Status Updated Successfully");
                    })
                    .catch((err) => {
                      this.isLoading = false;
                      this.$toast.error("Failed to update status.");
                      this.show = false;
                    });
              }
              else
              {
                this.Purchase.isUpdate=!this.Purchase.isUpdate
              }
            });

      }

    },
    closePreview() {
        this.purchaseBillVisible=false;
    },
    GotoPrintDetails() {
      setTimeout(() => {
        this.purchaseBillVisible=true;
      }, 100);
    },

    getPurchaseOrderStatusColor(status) {
      switch (status) {
       case "Completed":
          return "green";
          break;
        case "Pending":
          return "orange";
          break;
        case "Canceled":
          return "red";
          break;
        case "Return":
          return "#973a5a";
          break;
        default:
          break;
      }
    },
    refreshAdditionalAmountTable() {
      this.GetPurchase();
    },
    async getOrganization() {
      await this.$store
        .dispatch("sitesetting/OrganizationView", 1)
        .then((res) => {
        
          if (res && res.data) {
          
            this.Purchase.organization = res.data;
            // console.clear();
          
          }
        })
        .catch((err) => {});
    },
  },

  components: {
    FileUpload,
    EditPaymentModel,
    DocumentView,
    AddPaymentModel,
    AdditionalAmountModel,
    VueDocPreview,
    ChangeStatus,
    purchasebill,
    SalesPaymentEditModal,
  },
  created() {
    this.DocumentView();
    this.GetPurchase();
  },
  computed: {
    printQr() {
      return {
        id: "purchase",
        popTitle: this.Purchase.referenceNumber,
      };
    },
  },
};
</script>

<style scoped>
  .v-card__title {
    border-bottom: 1px solid lightgray !important;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    font-size: 16px !important;
    font-weight: lighter !important;
    color: #001e3f;
    font-family: "Roboto", sans-serif !important;
    font-weight: bold !important;
    padding-left: 20px !important;
    font-family: "Nunito", sans-serif !important;
  }
  .purchaseDetail{
    font-weight: bold;
  }
  .subtextlable {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 9px;
    line-height: 11px;
    /* identical to box height */

    text-align: left;

    color: #928686;
  }
  .shoptext {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 14px;
    /* identical to box height */

    text-align: center;

    color: #000000;
  }
  .statustext {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 12px;
    /* identical to box height */

    text-align: center;

    color: #045894;
  }
  .v-card__title {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    font-size: 1.25rem;
    font-weight: 500;
    letter-spacing: 0.0125em;
    line-height: 2rem;
    word-break: break-all;
  }
  .container {
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    background-color: white;
  }
  .saledetailscard {
    background: #fffefe;
    box-sizing: border-box;
    border: 1px solid #afa9a9;
    box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
  }
  .reference_number {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 21px;
    /* identical to box height */

    text-align: center;

    color: #000000;
  }
  .saletiltle {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
  }
</style>